module.exports = {
	hooks: {
		attach: function($element, options){
			$element.find('.owl-carousel').owlCarousel({
				autoPlay : true,
				slideSpeed : 300,
				paginationSpeed : 400,
				singleItem:true
			});
		}
	}
};